import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import StoreRegister from "../pages/StoreRegister";
import StoreLoginWithOtp from "../pages/StoreLoginWithOtp";
import StoreVerifyOtp from "../pages/StoreVerifyOtp";

const AuthModal = ({ isOpen, toggle, forceRegister = false }) => {
  const [mode, setMode] = useState(forceRegister ? "register" : "login");
  const [registrationData, setRegistrationData] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setMode(forceRegister ? "register" : "login");
    setRegistrationData(null);
  }, [isOpen, forceRegister]);

  if (!isOpen) return null;

  if (mode === "postLoginProfile") {
    return (
      <StoreRegister
        isOpen={isOpen}
        postLoginMode
        initialData={registrationData}
        onProfileComplete={toggle}
        onClose={toggle}
      />
    );
  }

  if (mode === "register") {
    return (
      <StoreRegister
        isOpen={isOpen}
        onClose={toggle}
        onSwitchToLogin={() => setMode("login")}
        onOtpGenerated={(data) => {
          setRegistrationData(data);
          setMode("verify");
        }}
      />
    );
  }

  if (mode === "login") {
    return (
      <StoreLoginWithOtp
        isOpen={isOpen}
        onClose={toggle}
        onSwitchToRegister={() => setMode("register")}
        onRequireRegistration={(data) => {
          setRegistrationData(data);
          setMode("postLoginProfile");
        }}
      />
    );
  }

  if (mode === "verify") {
    return (
      <StoreVerifyOtp
        isOpen={isOpen}
        onClose={toggle}
        onBackToRegister={() => setMode("register")}
        registrationData={registrationData}
      />
    );
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {forceRegister ? "Create Your ZeroBuild Account" : "Login or Register"}
      </ModalHeader>
      <ModalBody>
        <p className="text-muted mb-3">
          Please login or register to continue with store actions.
        </p>
        <div className="d-grid gap-2">
          <Button color="primary" onClick={() => setMode("login")}>
            Login
          </Button>
          <Button color="light" onClick={() => setMode("register")}>
            Register
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AuthModal;
